import { DatePicker } from "antd";
import React, { useMemo } from 'react';
import { IPropsElement } from "../../../pages/ChecklistPage/PopupEdit/constants";
import { datetime } from "../../../util/library/datetime";
import { propContainer } from "../../../util/varibles/constants";
import { callEventChecklist, getChecklist, useChecklist } from "../ChecklistContext";

const TimeFormat = "HH:mm"

const DateElement: React.FC<IPropsElement> = (props) => {
    const { index } = props;
    const { separator, isShowTime, ...args } = props.properties;
    const [value] = useChecklist(state => state.result[index]);
    const { onResultChange } = callEventChecklist();
    const { disabled } = getChecklist()();
    const format = useMemo(() => {
        const data = ['YYYY', 'MM', 'DD'].join(separator);
        if (isShowTime)
            return [data, TimeFormat].join(' ');
        return data;
    }, [separator, isShowTime]);

    return <DatePicker
        {...propContainer}
        {...args}
        showTime={isShowTime ? { format: "HH:mm" } : false}
        format={format}
        value={value ? datetime(value).value : undefined}
        disabled={disabled}
        onChange={value => onResultChange({ [index]: datetime(value).time })}
    />
};

export default DateElement;
